import React, { useCallback } from 'react';

import { RemixOverlay as RemixOptionsOverlay } from './remix-overlay';

/**
 * Props for the Remix container composed entry point.
 */
interface RemixContainerProps {
	/** The text content currently selected by the user, shown in the remix options overlay. */
	selectedText: string;
	/** Called when the user dismisses the remix flow (e.g. closes the overlay or preview). */
	onClose: () => void;
	/** Optional callback when the user selects a remix type (e.g. chart, diagram, visual aid, database). */
	onOptionSelect?: (type: string) => void;
}

/**
 * Composed entry point for the Remix feature.
 *
 * Step 1 – the user picks a remix type via RemixOptionsOverlay.
 * Step 2 – the AIFC staging modal opens.
 */
export function RemixContainer({
	selectedText,
	onClose,
	onOptionSelect,
}: RemixContainerProps): React.ReactElement {
	const handleOptionSelect = useCallback(
		(type: string) => {
			onOptionSelect?.(type);
		},
		[onOptionSelect],
	);

	return (
		<RemixOptionsOverlay
			selectedText={selectedText}
			onClose={onClose}
			onOptionSelect={handleOptionSelect}
		/>
	);
}
